import React from "react";

const Section = ({ children }) => {
	return (
		<section className="section">
			<div className="shell">{children}</div>
		</section>
	);
};

export default Section;
